import { Roles } from "../constants/roles";
import { bindRoleClick } from "../util/tabs/tabs-listener";
import type { AboutUsTabsForm } from "./about-us-tabs-form";
import type { AboutUsTabsHandler } from "./about-us-tabs-handler";

export class AboutUsTabsListener {
    private readonly form: AboutUsTabsForm;

    private readonly handler: AboutUsTabsHandler;

    public constructor(form: AboutUsTabsForm, handler: AboutUsTabsHandler) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        bindRoleClick(this.form.getRoot(), Roles.ABOUT_US_TAB, (_event, element) => {
            this.handler.handleTabClick(element);
        });

        window.addEventListener("popstate", () => {
            this.handler.handlePopState();
        });
    }
}
